module.exports = __webpack_public_path__ + "static/media/1002.070a5f0f.jpg";